import Vue from 'vue'
import VueI18n from 'vue-i18n'
import PortalSettings from '@/models/PortalSettings';
import store from '@/store'
import enUS from '@/locales/en-US.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en-US', 
  fallbackLocale: 'en-US',
  silentTranslationWarn: true
});


export default i18n;

const loadedLanguages = [];

function setI18nLanguage(lang, messages) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);

  if (messages) {
    let overrides = PortalSettings.get('lang', {}).overrides;
    loadedLanguages.push(lang);

    i18n.mergeLocaleMessage(lang, messages);

    if (overrides && overrides[lang]) {
      i18n.mergeLocaleMessage(lang, overrides[lang]);
    }
  }

  return lang;
}

export function loadLanguageAsync(lang) {
  // check if our fallback lang is loaded first. 
  if (!loadedLanguages.includes('en-US')) {
    setI18nLanguage('en-US', enUS);
  }

  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}.json`).then(msgs => {
        return setI18nLanguage(lang, msgs.default);
      })
    } 
  }
  return Promise.resolve(setI18nLanguage(lang));
}

export function mergeAllLocaleMessages(messages) {
  for (let key in messages) {
    if (messages.hasOwnProperty(key)) {
      // console.log('merge', key, messages[key]);
      i18n.mergeLocaleMessage(key, messages[key]);  
    }
  }
}
